import { Grid, Box, Typography } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";

const renderCheckIcon = ({
  width,
  height,
}: {
  width: string;
  height: string;
}) => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 98.5 98.5"
      enableBackground="new 0 0 98.5 98.5"
      xmlSpace="preserve"
      width={width}
      height={height}
    >
      <path
        className="checkmark"
        fill="none"
        strokeWidth={8}
        strokeMiterlimit={10}
        d="M81.7,17.8C73.5,9.3,62,4,49.2,4 C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
      />
    </svg>
  );
};

const ThankYouPreview = ({
  product,
  previewAgent,
}: {
  product: any;
  previewAgent: boolean;
}) => {
  const { branding } = product;

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        sx={{ marginBottom: previewAgent ? "15px" : "5px" }}
      >
        {renderCheckIcon({
          width: previewAgent ? "100px" : "50px",
          height: previewAgent ? "100px" : "50px",
        })}
      </Box>
      <Typography
        sx={{
          color: branding?.[brandingConstants.mainTitleColor],
          fontFamily: branding?.[brandingConstants.mainTitleFontFamily],
          fontSize: handleConvertPxToPt(
            branding?.[brandingConstants.mainTitleFontSize],
            previewAgent
          ),
          fontWeight: "900",
          textAlign: "center",
          mb: 0,
        }}
      >
        {product?.thanksStr}
      </Typography>
      <Typography
        sx={{
          marginTop: "10px",
          mb: 0,
          color: branding?.[brandingConstants.subTitleColor],
          fontFamily: branding?.[brandingConstants.subTitleFontFamily],
          fontSize: handleConvertPxToPt(
            branding?.[brandingConstants.subTitleFontSize],
            previewAgent
          ),
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        {product?.feedbackSettings?.thanksMsg}
      </Typography>
    </Grid>
  );
};

export default ThankYouPreview;
